(function () {
  'use strict';

  var nameCanvas = document.createElement('canvas').getContext('2d');
  var splitOptionName = function (element) {
    var full = element.dataset.kbdFullName;
    var style = getComputedStyle(element);
    var width = element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    if (!full || width <= 0) return;
    nameCanvas.font = style.font;
    var measure = function (text) { return nameCanvas.measureText(text).width; };
    var first = full;
    var second = '';
    if (measure(full) > width) {
      var words = full.split(' ');
      first = words.shift();
      while (words.length && measure(first + ' ' + words[0]) <= width) first += ' ' + words.shift();
      if (measure(first) > width) {
        var characters = Array.from(first);
        first = '';
        while (characters.length && measure(first + characters[0]) <= width) first += characters.shift();
        second = characters.join('') + (words.length ? ' ' + words.join(' ') : '');
      } else second = words.join(' ');
    }
    element.replaceChildren();
    [first, second].forEach(function (text, index) {
      var line = document.createElement('span');
      line.className = 'kbd-option-name__line';
      var content = document.createElement('span');
      content.className = 'kbd-option-name__text';
      content.textContent = text;
      line.appendChild(content);
      element.appendChild(line);
      var overflow = measure(text) - width;
      if (index === 1 && overflow > 1) {
        line.classList.add('kbd-option-name__line--scroll');
        line.style.setProperty('--kbd-name-offset', -Math.ceil(overflow + 2) + 'px');
        line.style.setProperty('--kbd-name-duration', Math.max(6, overflow / 22 + 3) / 2 + 's');
      }
    });
  };
  var nameResize = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.target.isConnected) nameResize.unobserve(entry.target);
      else splitOptionName(entry.target);
    });
  });
  var initOptionNames = function (scope) {
    scope.querySelectorAll('.option-selector--image-cards .opt-label--image .js-value').forEach(function (element) {
      if (element.dataset.kbdFullName) return;
      element.dataset.kbdFullName = element.textContent.trim().replace(/\s+/g, ' ');
      element.closest('label').setAttribute('title', element.dataset.kbdFullName);
      element.closest('label').setAttribute('aria-label', element.dataset.kbdFullName);
      element.setAttribute('aria-hidden', 'true');
      element.classList.add('kbd-option-name');
      nameResize.observe(element);
      splitOptionName(element);
    });
  };

  var arrow = function (direction) {
    var isPrevious = direction === 'prev';
    var path = isPrevious ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5';
    var label = isPrevious ? 'Previous images' : 'Next images';
    return '<button type="button" class="slick-' + direction + '" aria-label="' + label + '">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + path + '"></path></svg>' +
      '</button>';
  };

  var initThumbnailSliders = function (scope) {
    if (!window.jQuery || !jQuery.fn.slick) return;

    jQuery(scope).find('.section-product-template .product-detail__thumbnails').each(function () {
      var $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) return;

      $slider.addClass('kbd-thumbnail-slider').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        dots: false,
        prevArrow: arrow('prev'),
        nextArrow: arrow('next'),
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 4, slidesToScroll: 4 }
          },
          {
            breakpoint: 900,
            settings: { slidesToShow: 3, slidesToScroll: 3 }
          }
        ]
      });

      $slider.on('click', '.product-detail__thumbnail', function () {
        var index = jQuery(this).data('slick-index');
        if (typeof index === 'number') $slider.slick('slickGoTo', index);
      });
    });
  };

  var revealProductBelow = function (scope) {
    var section = scope.closest && scope.closest('.section-product-template') || scope.querySelector && scope.querySelector('.section-product-template');
    if (!section) return;

    var below = section.querySelector('[data-kbd-product-below]');
    if (!below || below.dataset.kbdRevealReady === 'true') return;
    below.dataset.kbdRevealReady = 'true';

    var reveal = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          below.classList.add('kbd-product-below--ready');
        });
      });
    };

    var primaryImage = section.querySelector('.product-detail__image:first-child img');
    if (!primaryImage || primaryImage.complete && primaryImage.naturalWidth > 0) {
      reveal();
      return;
    }

    primaryImage.addEventListener('load', reveal, { once: true });
    primaryImage.addEventListener('error', reveal, { once: true });
    window.setTimeout(reveal, 4000);
  };

  var addMissingProductImageAlt = function (scope) {
    var sections = scope.querySelectorAll ? scope.querySelectorAll('.section-product-template') : [];
    Array.prototype.forEach.call(sections, function (section) {
      var heading = section.querySelector('h1');
      var fallback = heading ? heading.textContent.trim() : document.title.split(/[-|]/)[0].trim();
      if (!fallback) return;
      section.querySelectorAll('img:not([alt]), img[alt=""]').forEach(function (image) {
        image.alt = fallback;
      });
    });
  };

  var initDeferredDescriptions = function (scope) {
    var descriptions = [];
    if (scope.matches && scope.matches('[data-kbd-deferred-description]')) descriptions.push(scope);
    if (scope.querySelectorAll) {
      descriptions = descriptions.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-kbd-deferred-description]')));
    }
    descriptions.forEach(function (description) {
      if (description.dataset.kbdDeferredReady === 'true') return;
      description.dataset.kbdDeferredReady = 'true';
      description.open = false;
    });
  };

  var collapseConfiguratorDescriptions = function (scope) {
    var descriptions = [];
    if (scope.matches && scope.matches('.typelab-product-description')) descriptions.push(scope);
    if (scope.querySelectorAll) {
      descriptions = descriptions.concat(Array.prototype.slice.call(scope.querySelectorAll('.typelab-product-description')));
    }
    descriptions.forEach(function (description) {
      if (description.dataset.kbdDefaultCollapsed === 'true') return;
      description.dataset.kbdDefaultCollapsed = 'true';
      description.open = false;
    });
  };

  var initConfiguratorLoadingGate = function () {
    var root = document.documentElement;
    if (!root.classList.contains('kbd-configurator-pending')) return;

    var startedAt = performance.now();
    var finished = false;
    var observer;
    var revealTimer;

    var reveal = function () {
      if (finished) return;
      finished = true;
      if (observer) observer.disconnect();
      window.clearTimeout(revealTimer);
      root.classList.remove('kbd-configurator-pending');
      root.classList.add('kbd-configurator-ready');
      var main = document.getElementById('MainContent');
      if (main) main.setAttribute('aria-busy', 'false');
    };

    var scheduleReveal = function () {
      if (finished || revealTimer) return;
      var remaining = Math.max(0, 280 - (performance.now() - startedAt));
      revealTimer = window.setTimeout(reveal, remaining);
    };

    var check = function () {
      if (finished) return;
      var shell = document.querySelector('.typelab-configurator-shell');
      if (!shell) return;
      var internalLoader = shell.querySelector('[data-typelab-loading]');
      var previewReady = shell.querySelector('.typelab-preview-frame.is-ready');
      var optionsReady = shell.querySelector('.typelab-option-button');
      var progressReady = shell.querySelector('.typelab-progress');
      if (previewReady && optionsReady && progressReady && (!internalLoader || internalLoader.hidden)) {
        scheduleReveal();
      }
    };

    observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });
    check();
  };

  var descriptionJump;
  var activeDescription;
  var jumpUpdateQueued = false;
  var descriptionSelector = 'details.kbd-deferred-description, details.typelab-product-description';

  var updateDescriptionJump = function () {
    jumpUpdateQueued = false;
    if (!descriptionJump) return;
    activeDescription = Array.prototype.find.call(document.querySelectorAll(descriptionSelector), function (description) {
      if (!description.open || !description.getClientRects().length) return false;
      var rect = description.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.78 && rect.bottom > window.innerHeight * 0.22;
    }) || null;
    if (activeDescription) {
      var descriptionRect = activeDescription.getBoundingClientRect();
      var controlWidth = 48;
      var viewportPadding = 12;
      var detailGap = 16;
      var maximumLeft = window.innerWidth - controlWidth - viewportPadding;
      var preferredLeft = descriptionRect.right + detailGap;
      var insideLeft = descriptionRect.right - controlWidth - detailGap;
      var controlLeft = preferredLeft <= maximumLeft ? preferredLeft : insideLeft;
      descriptionJump.style.setProperty(
        '--kbd-description-jump-left',
        Math.round(Math.max(viewportPadding, Math.min(controlLeft, maximumLeft))) + 'px'
      );
    }
    descriptionJump.classList.toggle('is-visible', Boolean(activeDescription));
    descriptionJump.setAttribute('aria-hidden', activeDescription ? 'false' : 'true');
    descriptionJump.querySelectorAll('button').forEach(function (button) {
      button.tabIndex = activeDescription ? 0 : -1;
    });
  };

  var scheduleDescriptionJumpUpdate = function () {
    if (jumpUpdateQueued) return;
    jumpUpdateQueued = true;
    window.requestAnimationFrame(updateDescriptionJump);
  };

  var scrollToDescriptionEdge = function (direction) {
    if (!activeDescription) return;
    var rect = activeDescription.getBoundingClientRect();
    var target = direction === 'top'
      ? window.scrollY + rect.top - 20
      : window.scrollY + rect.bottom - window.innerHeight + 20;
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: Math.max(0, target), behavior: behavior });
  };

  var initDescriptionJump = function () {
    if (descriptionJump) {
      scheduleDescriptionJumpUpdate();
      return;
    }
    descriptionJump = document.createElement('div');
    descriptionJump.className = 'kbd-description-jump';
    descriptionJump.setAttribute('aria-hidden', 'true');
    descriptionJump.innerHTML = '<button type="button" class="kbd-description-jump__button" data-kbd-description-jump="top" aria-label="Top of product details" title="Top of product details" tabindex="-1"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 19V5M6 11l6-6 6 6"></path></svg></button><button type="button" class="kbd-description-jump__button" data-kbd-description-jump="bottom" aria-label="Bottom of product details" title="Bottom of product details" tabindex="-1"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M6 13l6 6 6-6"></path></svg></button>';
    descriptionJump.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kbd-description-jump]');
      if (button) scrollToDescriptionEdge(button.dataset.kbdDescriptionJump);
    });
    document.body.appendChild(descriptionJump);
    window.addEventListener('scroll', scheduleDescriptionJumpUpdate, { passive: true });
    window.addEventListener('resize', scheduleDescriptionJumpUpdate);
    document.addEventListener('toggle', scheduleDescriptionJumpUpdate, true);
    scheduleDescriptionJumpUpdate();
  };

  document.addEventListener('DOMContentLoaded', function () {
    initOptionNames(document);
    initDeferredDescriptions(document);
    collapseConfiguratorDescriptions(document);
    initConfiguratorLoadingGate();
    initDescriptionJump();
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.querySelector('.opt-label--image .js-value')) initOptionNames(node);
          initDeferredDescriptions(node);
          collapseConfiguratorDescriptions(node);
          scheduleDescriptionJumpUpdate();
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.fonts.ready.then(function () {
      document.querySelectorAll('.kbd-option-name').forEach(splitOptionName);
    });
    initThumbnailSliders(document);
    revealProductBelow(document);
    addMissingProductImageAlt(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initOptionNames(event.target);
    initThumbnailSliders(event.target);
    revealProductBelow(event.target);
    addMissingProductImageAlt(event.target);
    initDeferredDescriptions(event.target);
    collapseConfiguratorDescriptions(event.target);
    initDescriptionJump();
  });
})();
